






















































import { Destroyed } from '../../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import {
    MsgBox,
    Button,
    Combobox,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal,
    Input,
    DatePickerSingle
} from '../../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../../core/mixins';
import { InsuranceServices } from '../../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import { editableField, EditableHarvestRanchFields, editRanchEditableField, HarvestRanchEditableFields, HarvestRanchEditableFieldType, ManualHarvestRanchValue, RanchFieldPriority, SatelitalHarvestRanchValue, TelematicHarvestRanchValue } from '../../ranch';
import { getValueByType } from '../../../core/api';
import { calculateSowingDate } from '../../../insurance/api/sowingModels';
import { formattedDate, isNullOrEmpty, isValidDate, KeyNames } from '../../../core/utils';

@Component({
    components: {
        Loading,
        Combobox,
        Button,
        Input,
        DatePickerSingle
    }
})
export default class RanchEditEstimatedDate extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    @Prop({default: null}) ranchId: number;
    @Prop({default: '-'}) patchDate: string;
    savingEstimatedDate: boolean = false;
    fieldName: string = KeyNames.estimated_harvest_date;
    dateValue: string = '';

    mounted(){
        if(isValidDate(this.patchDate)){
            this.dateValue = this.patchDate
        }
    }

    updateDateValue(value){
        this.dateValue = value;
    }
    

    
    showLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    showSuccessLoadingDialog(response, alternative_msg){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg
        });
        this.closeModal();
    }
    showCatchLoadingDialog(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    

    saveEstimatedDate() {
       this.savingEstimatedDate = true;
        InsuranceServices.modifyRanchEstimatedHarvestDate(
            Number(this.ranchId),
            this.dateValue
        ).then((res) => {
            this.$_successAddRecipients(res.message);
            this.updateHarvestedEstimatedDate(this.dateValue);
            this.closeModal();
        }).catch((err)=> {
            this.showCatchLoadingDialog(err, 'No se pudo modificar la Fecha Estimada de Cosecha');
        }).finally(() => {
            this.savingEstimatedDate = false;
        })
       
    }

    @Emit()
    updateHarvestedEstimatedDate(dateValue:string){}


    @Emit()
    closeModal() {}

    doNothing(){}

}
